import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DRAFT_EVENTS = ['onBeforeInput', 'onBlur', 'onClick', 'onCompositionEnd', 'onCompositionStart', 'onCopy', 'onCut', 'onDragEnd', 'onDragEnter', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onFocus', 'onInput', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onMouseDown', 'onMouseUp', 'onPaste', 'onSelect'];
export default (Component => {
  class EventBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.handlers = DRAFT_EVENTS.reduce((acc, eventName) => {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[eventName] = e => {
          if (e && e.stopPropagation) {
            e.stopPropagation();
          }
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          if (this.props[eventName]) {
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            this.props[eventName](e);
          }
        };
        return acc;
      }, {});
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, this.handlers));
    }
  }
  EventBoundary.propTypes = Object.assign({}, Component.propTypes);
  EventBoundary.defaultProps = Object.assign({}, Component.defaultProps);
  return EventBoundary;
});